type blobUrlBuilder = (base64Data: string, mimeType: string) => string

export function useBase64BlobUrl(): blobUrlBuilder {
  const buildBlobURL = (base64Data: string, mimeType: string): string => {
    const cleanedBase64 = base64Data.includes(',') ? base64Data.split(',')?.[1] : base64Data
    if (cleanedBase64) {
      const byteCharacters = atob(cleanedBase64)
      const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0))
      const byteArray = new Uint8Array(byteNumbers)

      const blob = new Blob([byteArray], { type: mimeType })

      return URL.createObjectURL(blob)
    }

    return ''
  }

  return buildBlobURL
}
